export default __webpack_public_path__ + "static/media/download.6ed958db.png";